export enum DeliveryStates {
    NOT_STARTED,
    STARTED,
    PAUSED,
    WAITING,
    MISC,
    ENDED,
}
